<app-progress-dashboard-chart-container
  [data]="data()"
  [label]="label()"
  [options]="options()"
  type="pie"
/>
